import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-add_manully",
  "use": "icon-add_manully-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-add_manully\">\n\t<path fill=\"none\" d=\"M0,0H24V24H0Z\" />\n\t<path d=\"M10.89,10.89V6.44h2.22v4.45h4.45v2.22H13.11v4.45H10.89V13.11H6.44V10.89ZM4.22,4.22V19.78H19.78V4.22ZM3.11,2H20.89A1.11,1.11,0,0,1,22,3.11V20.89A1.11,1.11,0,0,1,20.89,22H3.11A1.11,1.11,0,0,1,2,20.89V3.11A1.11,1.11,0,0,1,3.11,2Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol